export interface ChargeGroup {
    name: string;
    color: string;
    nbr: number;
    angle?: number; // not implemented yet
}

export interface Field {
    color: string;
    charges?: ChargeGroup;
    fullCharge?: boolean; // not implemented yet
}

export interface Division {
    kind: string;
    color: string;
    charges?: ChargeGroup;
    arrondi?: boolean; // not implemented yet
}

export interface Ordinary {
    kind: string;
    color: string;
    charges?: ChargeGroup;
}

export interface Device {
    shield?: string;

    field: Field;
    division?: Division;
    ordinary?: Ordinary;
}

export const DEFAULT_DEVICE: Device = {
    shield: "HEATER",

    field: {
        color: "RED",
        fullCharge: false,
        charges: {
            name: "tower",
            color: "GOLD",
            nbr: 1,
        }
    },

    // division: {
    //     kind: "SALTIRE",
    //     color: "BLACK",
    //     charges: {
    //         name: "tower",
    //         color: "GOLD",
    //         nbr: 1,
    //     }
    // },
};

/** input = json string */
export function blazonToDevice(blazon: any): Device {
    const device: Device = blazon;
    return device;
}

/** output = json string */
export function deviceToBlazon(device: Device): string {
    // device.field.fullCharge = false;
    return JSON.stringify(device);
}

const COMPATIBLE_ORDINARIES = {
    BEND: ["BEND"],
    BEND_SINISTER: ["BEND_SINISTER"],
    CHEVRON: ["CHEVRON", "SALTIRE"],
    FESS: ["FESS", "PALE", "CROSS"],
    GYRONNY: ["CHEVRON", "BEND_SINISTER", "FESS", "BEND", "SALTIRE", "PALE", "CROSS"],
    PALE: ["CHEVRON", "FESS", "SALTIRE", "PALE", "CROSS"],
    QUARTER: ["CHEVRON", "BEND_SINISTER", "FESS", "BEND", "SALTIRE", "PALE", "CROSS"],
    SALTIRE: ["CHEVRON", "FESS", "SALTIRE", "PALE", "CROSS"],
};
type DIVISION_TYPE = keyof typeof COMPATIBLE_ORDINARIES;
export const ORDINARIES = ["BEND", "BEND_SINISTER", "CHEVRON", "FESS", "GYRONY", "PALE", "QUARTER", "SALTIRE"];

export function divisonAndOrdinaryAllowed(division?: string, ordinary?: string): boolean {
    if (!division || !ordinary) {
        return true;
    }
    const compatibleOrdinaries = COMPATIBLE_ORDINARIES[division as DIVISION_TYPE];
    console.log(`divisonAndOrdinaryAllowed: division=${division} compatibleOrdinaries=${compatibleOrdinaries}`);
    const result = compatibleOrdinaries.includes(ordinary);
    return result;
}
